import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./Diesel.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext"; 
import { ProcessContext } from "../context/ProcessContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";


import { trackPageVisit } from "../competency/PageTracker";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}



function Diesel() {

    useEffect(() => {
    
      trackPageVisit("Diesel");
    
    }, []);
  
     const {  valves, toggleValve} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
  const {processData,  setProcessData} = useContext(ProcessContext);

     

  const DEFAULT_VALVES = {
  FCV_3601: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3602: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3603: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_3604: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Diesel_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      FCV_3601: { ...DEFAULT_VALVES.FCV_3601, ...parsed.FCV_3601 },
      FCV_3602: { ...DEFAULT_VALVES.FCV_3602, ...parsed.FCV_3602 },
      FCV_3603: { ...DEFAULT_VALVES.FCV_3603, ...parsed.FCV_3603 },
      FCV_3604: { ...DEFAULT_VALVES.FCV_3604, ...parsed.FCV_3604 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Diesel_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };


// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================
    
                const { transmitters,  } = usePlantStore();
                const TT_33031 = transmitters.TT_33031 || 0;
                const PT_33031 = transmitters.PT_33031 || 0;
                const FIC_3303 = transmitters.FIC_3303 || 0;
                const FIC_19051 = transmitters.FIC_19051 || 0;
                const PT_19051 = transmitters.PT_19051 || 0;

  




  const xv3601Open = !valves?.XV_3601;
  const xv3602Open = !valves?.XV_3602;
  const xv3603Open = !valves?.XV_3603;
  const xv3604Open = !valves?.XV_3604;
  const xv3605Open = !valves?.XV_3605;
  const xv3606Open = !valves?.XV_3606;


    const FIC_3601 = FIC_3303;
    const FIC_36011 = FIC_19051;
    const PT_3601 = PT_19051;
    const PT_3602 = PT_33031;

    let PT_3603 = 0.03;

        if (PT_3601 > 0 && PT_3602 > 0) {
        PT_3603 = (PT_3601 + PT_3602) / 2;
        } else if (PT_3601 > 0) {
        PT_3603 = PT_3601;
        } else if (PT_3602 > 0) {
        PT_3603 = PT_3602;
        } else {
        PT_3603 = 0.03;
        }


    
/* =========================================================
              SPLITTING MAIN Diesel LINE
========================================================= */

const openDieselTankSplit =
[
  xv3601Open,
  xv3602Open
].filter(Boolean).length;

const FIC_3602 =
  xv3601Open
    ? (FIC_3601 + FIC_36011) / openDieselTankSplit
    : 0;

const FIC_3603 =
  xv3602Open
    ? (FIC_3601 + FIC_36011) / openDieselTankSplit
    : 0;






/* =========================================================
   PUMP CONTEXT
========================================================= */

const pumpContext = useContext(PumpContext) || {};
const pumpData = pumpContext.pumpData || {};
const togglePump = pumpContext.togglePump || (() => {});

/* =========================================================
   P-3601A / P-3601B STATUS
========================================================= */

const P3601A_Running =
pumpData?.["P-3601A"]?.running ?? false;

const P3601B_Running =
pumpData?.["P-3601B"]?.running ?? false;

const P3601_Running =
P3601A_Running || P3601B_Running;


/* =========================================================
   PUMP CAPACITY
========================================================= */

const P3601_CAPACITY = 12.5;


/* =========================================================
   CONTROL VALVE
========================================================= */

const FCV3601_Opening =
(valveData?.FCV_3601?.opening || 0) / 100;


/* =========================================================
   TARGET FLOW
========================================================= */

const targetFIC3604 =
(
P3601_Running
)
?
P3601_CAPACITY *
FCV3601_Opening
:
0;


/* =========================================================
   FLOW UPDATE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const current =
Number(prev.FIC_3604 || 0);

const next =
current +
(targetFIC3604-current)*0.12;

return{

...prev,

FIC_3604:
Number(next.toFixed(3))

};

});

},500);

return()=>clearInterval(timer);

},
[
targetFIC3604
]);



/* =========================================================
   PRESSURE + TEMPERATURE ENGINE
========================================================= */

useEffect(()=>{

const timer=setInterval(()=>{

setProcessData(prev=>{

const currentPressure =
Number(prev.PT_3604 || 0.03);

const currentTemp =
Number(prev.TT_3604 || 28);

const currentFlow =
Number(prev.FIC_3604 || 0);

let targetPressure = 0.03;
let targetTemp = 28;


/* =========================================
   PUMP RUNNING
========================================= */

if(P3601_Running){

/* -----------------------------------------
   PRESSURE
----------------------------------------- */

// Dead-head (Valve fully closed)

if(FCV3601_Opening<=0){

targetPressure=1.80;

}

// Highly restricted

else if(FCV3601_Opening<0.20){

const restriction =
(0.20-FCV3601_Opening)/0.20;

targetPressure=
0.80+
restriction*
1.00;

}

// Normal operation

else{

targetPressure=
0.80-
(
FCV3601_Opening-
0.20
)*0.18;

}


/* -----------------------------------------
   TEMPERATURE
----------------------------------------- */

targetTemp=28;

// Dead-head heating

if(FCV3601_Opening<=0){

targetTemp=36;

}

// Restricted flow heating

else if(FCV3601_Opening<0.20){

const restriction=
(0.20-FCV3601_Opening)/0.20;

targetTemp=
28+
restriction*4;

}

}


/* =========================================
   UPDATE
========================================= */

return{

...prev,

PT_3604:
Number(
(
currentPressure+
(
targetPressure-currentPressure
)*0.08
).toFixed(3)
),

TT_3604:
Number(
(
currentTemp+
(
targetTemp-currentTemp
)*0.08
).toFixed(2)
)

};

});

},500);

return()=>clearInterval(timer);

},
[
P3601_Running,
FCV3601_Opening
]);


/* =========================================================
   TRANSMITTERS
========================================================= */

const FIC_3604 =
Number(
processData.FIC_3604 || 0
);

const PT_3604 =
Number(
processData.PT_3604 || 0.03
);

const TT_3604 =
Number(
processData.TT_3604 || 28
);





/* =========================================================
   V-3601 SUCTION FLOW
========================================================= */
const FIC_3605 = (P3601A_Running && xv3603Open) ? FIC_3604 : 0.003;

/* =========================================================
   V-3602 SUCTION FLOW
========================================================= */
const FIC_3606 = (P3601A_Running && xv3604Open) ? FIC_3604 : 0.003;











    
/* =========================================================
              SPLITTING MAIN Diesel LINE
========================================================= */



const openDieselLineSplit =
[
  xv3605Open,
  xv3606Open
].filter(Boolean).length;

const FIC_3607 =
  xv3605Open
    ? FIC_3604 / openDieselLineSplit
    : 0;

const FIC_3608 =
  xv3606Open
    ? FIC_3604 / openDieselLineSplit
    : 0;




useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_3607 === FIC_3607 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,
      FIC_3607,
    }
  });

}, [FIC_3607, ]);














  return (
    <div className="Diesel-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 361px",
          zIndex: 10,
        }}
      >
        DIESEL TANKS
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}

      
      {/* XV-3601 */}
      <Valve
        className="XV-3601"
        tag="XV_3601"
        x={314}
        y={355}
        isClosed={valves.XV_3601}
        toggle={toggleValve}
        r={270}
      />

      {/* XV-3602 */}
      <Valve
        className="XV-3602"
        tag="XV_3602"
        x={774}
        y={355}
        isClosed={valves.XV_3602}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3603 */}
      <Valve
        className="XV-3603"
        tag="XV_3603"
        x={534}
        y={365}
        isClosed={valves.XV_3603}
        toggle={toggleValve}
      />

      {/* XV-3604 */}
      <Valve
        className="XV-3604"
        tag="XV_3604"
        x={1083}
        y={355}
        isClosed={valves.XV_3604}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-3605 */}
      <Valve
        className="XV-3605"
        tag="XV_3605"
        x={1033}
        y={561}
        isClosed={valves.XV_3605}
        toggle={toggleValve}
      />

      {/* XV-3606 */}
      <Valve
        className="XV-3606"
        tag="XV_3606"
        x={1033}
        y={671}
        isClosed={valves.XV_3606}
        toggle={toggleValve}
      />




      
        {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-3601 */}
        <div
            style={{ position: "absolute", left: 865, top: 553}}
            onMouseEnter={() => setHoveredValve("FCV_3601")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_3601")}
          >

            {hoveredValve === "FCV_3601" && (
              <div style={tagStyle}>
                FCV_3601
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-3601">
                    
          <defs>
            <linearGradient id="metal_3601">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_3601)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_3601)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
     
      
        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 360 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 360 + index * 40
              }}
            />
          ))}





      {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.FCV_3601?.opening || 0)}
        x={887}
        y={600}
      />




    <Transmitter
        tag="FIC_3601"
        value={[FIC_3601]}
        x={121}
        y={325}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF FROM DIESEL AFTER COOLER E-116 TO DIESEL STORAGE TANKS)"
      />

    <Transmitter
        tag="FIC_36011"
        value={[FIC_36011]}
        x={151}
        y={259}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF FROM KEROSENE AFTER COOLER E-115 TO DIESEL STORAGE TANKS)"
      />

    <Transmitter
        tag="PT_3601"
        value={[PT_3601]}
        x={41}
        y={238}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF FROM KEROSENE AFTER COOLER E-115 TO DIESEL STORAGE TANKS)"
      />

    <Transmitter
        tag="PT_3603"
        value={[PT_3603]}
        x={181}
        y={455}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF FROM DIESEL AFTER COOLER E-116 TO DIESEL STORAGE TANKS)"
      />

      <Transmitter
        tag="FIC_3602"
        value={[FIC_3602]}
        x={281}
        y={255}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF Diesel FROM DIESEL AFTER COOLER E-116 TO DIESEL STORAGE TANKS)"
      />

      <Transmitter
        tag="FIC_3603"
        value={[FIC_3603]}
        x={741}
        y={255}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DIESEL FROM E-116 TO DIESEL STORAGE TANKS (V-306 AND V-307)"
      />

      <Transmitter
        tag="FIC_3604"
        value={[FIC_3604]}
        x={783}
        y={593}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DIESEL FROM P-3601A/B TO LOADING OR BLENDING"
      />


      <Transmitter
        tag="PT_3604"
        value={[PT_3604]}
        x={683}
        y={593}
        unit="MPa"
        max={1}
        HH={0.8}
        H={0.5}
        L={0}
        LL={0}
        c="lime"
        description="PRESSURE OF DIESEL FROM P-3601A/B TO LOADING OR BLENDING"
      />
    
    <Transmitter
        tag="TT_3604"
        value={[TT_3604]}
        x={683}
        y={503}
        unit="°C"
        max={600}
        HH={580}
        H={555}
        L={0}
        LL={0}
        c="lime"
        description="TEMPERATURE OF DIESEL FROM P-3601A/B TO LOADING OR BLENDING"
      />

      <Transmitter
        tag="FIC_3607"
        value={[FIC_3607]}
        x={1113}
        y={553}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DIESEL FROM P-3601A/B TO LOADING GANTRY"
      />

      <Transmitter
        tag="FIC_3608"
        value={[FIC_3608]}
        x={1113}
        y={663}
        unit="BPM"
        max={35}
        HH={34}
        H={30}
        L={0}
        LL={0}
        c="lime"
        description="FLOWRATE OF DIESEL FROM P-3601A/B TO FUEL OIL BLENDING TANK"
      />






      <LevelTransmitterIndicator
      tag="LT_3601"
      totalLevel={95000}
      inflows={[FIC_3602]}
      outflows={[FIC_3605]}
      responseFactor={0.05}
      columnX={563}
      columnY={139}
      columnWidth={30}
      columnHeight={179}
      textX={610}
      textY={150}
      showFlow={true}
      service="Diesel"
    />

    <LevelTransmitterIndicator
      tag="LT_3601"
      totalLevel={95000}
      inflows={[FIC_3602]}
      outflows={[FIC_3605]}
      responseFactor={0.05}
      columnX={396}
      columnY={139}
      columnWidth={199}
      columnHeight={181}
      textX={610}
      textY={150}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="Diesel"
    />


      <LevelTransmitterIndicator
      tag="LT_3602"
      totalLevel={95000}
      inflows={[FIC_3603]}
      outflows={[FIC_3606]}
      responseFactor={0.05}
      columnX={1009}
      columnY={139}
      columnWidth={30}
      columnHeight={179}
      textX={1050}
      textY={150}
      showFlow={true}
      service="Diesel"
    />

    <LevelTransmitterIndicator
      tag="LT_3602"
      totalLevel={95000}
      inflows={[FIC_3603]}
      outflows={[FIC_3606]}
      responseFactor={0.05}
      columnX={841}
      columnY={139}
      columnWidth={199}
      columnHeight={181}
      textX={1050}
      textY={150}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.1}
      service="Diesel"
    />



            <Pump
              tag="P-3601A"
              x={568}
              y={520}
              rpm={1800}
              bladeCount={pumpData?.["P-3601A"]?.bladeCount || 3}
              size={pumpData?.["P-3601A"]?.size || 45}
              onClick={openPumpPanel}
            />

            <Pump
              tag="P-3601B"
              x={568}
              y={614}
              rpm={1800}
              bladeCount={pumpData?.["P-3601B"]?.bladeCount || 3}
              size={pumpData?.["P-3601B"]?.size || 45}
              onClick={openPumpPanel}
            />






    </div>
  );
}

export default Diesel;